import { Component, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from 'src/app/services/notifications/notification.service';
import { UtilService } from 'src/app/services/util.service';
import { NotificationDTO } from '../../services/api/api';
import { ErrorService } from '../../services/error.service';
import { PermissionService } from '../../services/permission.service';

@Component({
  selector: 'sb-notification-list',
  templateUrl: './sb-notification-list.component.html',
  styleUrls: ['./sb-notification-list.component.scss'],
  standalone: false,
})
export class SbNotificationListComponent implements OnDestroy {
  hover: boolean;

  constructor(
    public notificationService: NotificationService,
    public errorHandler: ErrorService,
    public util: UtilService,
    public translate: TranslateService,
    public permissionService: PermissionService
  ) {
    this.hover = false;
  }

  ngOnDestroy(): void {
    this.notificationService.stop();
  }

  check(e, notification: NotificationDTO) {
    e.preventDefault();
    e.stopPropagation();
    this.notificationService
      .markAsRead(notification)
      .then(() => {
        this.notificationService.restart();
      })
      .catch(error => {
        this.errorHandler.errorHandler(error);
      });
  }
}
